import { render } from "./ServeCards.vue?vue&type=template&id=efe99098&scoped=true"
import script from "./ServeCards.vue?vue&type=script&lang=js"
export * from "./ServeCards.vue?vue&type=script&lang=js"

import "./ServeCards.vue?vue&type=style&index=0&id=efe99098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe99098"]])

export default __exports__